// extracted by mini-css-extract-plugin
module.exports = {"changeFolderSelector":"changeFolderSelector__2Xb-s"};